export enum PopUpTypes {
  NONE = 'NONE',
  CAMERA_ACCESS_ALERT = 'CAMERA_ACCESS_ALERT',
  SCAN_PROCESS = 'SCAN_PROCESS',
  UPLOAD_PROCESS = 'UPLOAD_PROCESS',
  ERROR = 'ERROR',
}
